import { render, staticRenderFns } from "./subscription-benefits.vue?vue&type=template&id=0e0fd0a0&"
import script from "./subscription-benefits.vue?vue&type=script&lang=js&"
export * from "./subscription-benefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports